module.exports = __webpack_public_path__ + "png/quick-registration-puzzle-3.png?647dbf273aeef6c7c395300d6a404b11";